/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-06T17:16:23-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-06T14:00:38-07:00
*/



import React, { Component } from 'react';
import glamorous from 'glamorous';
import Checkbox from '../../common/Checkbox';
import FilterSection from './FilterSection';
import CustomDateInput from './CustomDateInput';
import { color } from '../../../style';
import DatePicker from 'react-datepicker';
import moment from 'moment';

require('react-datepicker/dist/react-datepicker.css');

const ResetButton = glamorous.a({
  display: 'flex',
  cursor: 'pointer',
  fontSize: '16px',
  margin: '11px 11px 2px auto',
  borderBottom: '1px dashed #979797',
  width: '38px'
});

const DatePickerWrapper = glamorous.div({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-around',
  "@media(max-width: 800px)": {
    flexDirection: 'column'
  }
});

const Dash = glamorous.div({
  paddingTop: 10,
  "::before": {
    content: "—",
  "@media(max-width: 800px)": {
    display: "none"
  }
  }
})

const CalendarSeparator = glamorous.span({
  color: color.BRAND_1 
});


const getDateMin = (timestamp) => {
  if(timestamp) return moment(timestamp)
  else return moment()
}

class FiltersTravelingTo extends Component {
  render() {
    const {
      leaving,
      onLeaveSelected,
      returning,
      onReturnSelected,
      onCheckBoxChange,
      isCheckBoxChecked,
      onDatePickerReset
    } = this.props;

    return (
      <div>
        <FilterSection header="Date Range">
          <DatePickerWrapper>
            <DatePicker
              customInput={<CustomDateInput defaultText='Leaving' style={{padding:"10px 0"}} />}
              minDate={moment()}
              selected={leaving}
              onChange={onLeaveSelected}
            />
            <CalendarSeparator>
            <Dash />
            </CalendarSeparator>
            <DatePicker
              customInput={<CustomDateInput defaultText='Returning' style={{padding:"10px 0"}}/> }
              minDate={getDateMin(leaving)}
              selected={returning}
              onChange={onReturnSelected}
            />
          </DatePickerWrapper>
          <ResetButton variant="link" onClick={onDatePickerReset}>Reset</ResetButton>
        </FilterSection>
        <FilterSection header="Trip Costs">
          <Checkbox size='MD' value={isCheckBoxChecked('who_pays',1)} onChange={() => {onCheckBoxChange('who_pays',1)}} label="They pay trip costs" />
          <Checkbox size='MD' value={isCheckBoxChecked('who_pays',2)} onChange={() => {onCheckBoxChange('who_pays',2)}} label="You pay trip cost" />
          <Checkbox size='MD' value={isCheckBoxChecked('who_pays',3)} onChange={() => {onCheckBoxChange('who_pays',3)}} label="Split the trip cost" />
        </FilterSection>
      </div>
    );
  }
}

export default FiltersTravelingTo;



// WEBPACK FOOTER //
// ./src/components/pages/Search/FiltersTravelingTo.jsx